/**
 * @generated SignedSource<<658d73aeefa5d4a78157508bb8f2a990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Product_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly productPhotos: ReadonlyArray<{
    readonly masterOrZoomPath: string | null;
    readonly placeholder: string | null;
    readonly smallPath: string | null;
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionCountdown_item">;
  readonly " $fragmentType": "Product_item";
};
export type Product_item$key = {
  readonly " $data"?: Product_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"Product_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "showAuctionCountdown"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Product_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placeholder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "showAuctionCountdown",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "pageDisplayEnum"
            }
          ],
          "kind": "FragmentSpread",
          "name": "AuctionCountdown_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bdb5cb89da3e6561533d3b04360e1784";

export default node;
